import { ErrorDisplayProps } from 'components/molecules';
import { journalTexts } from 'consts/text';
import { NoScheduleDataStateIcon } from 'assets';

export const institutionNonWorkingDayErrorStateConfig: ErrorDisplayProps = {
    title: journalTexts.journalDetails.common.errorMessages.institutionNonWorkingDay,
    hideSubTitle: true,
    icon: <NoScheduleDataStateIcon />,
};
